import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import styles from "./index.module.css"

/**
 * "⚠ N bookings require action" — the red-surface row shown on a blackout day card, in the
 * day details panel and in the day-view banner.
 *
 * `onReview` adds the "Review ↗" link used where the design offers a jump to the affected
 * reservations; without it the row is informational only.
 */
const BookingsActionAlert = ({ count, onReview, isCompact = false, className = "" }) => {
  const { t } = useTranslation()

  if (!count) return null

  const message = isCompact
    ? t("calendar.blackout.bookings_require_action", {
        defaultValue: "{{count}} bookings require action",
        count
      })
    : t("calendar.blackout.bookings_require_rescheduling", {
        defaultValue: "{{count}} bookings require cancellation or rescheduling",
        count
      })

  return (
    <div className={`${styles.alert} ${isCompact ? styles.compact : ""} ${className}`}>
      <Icon name="AlertTriangle" width={isCompact ? 16 : 20} height={isCompact ? 16 : 20} color="var(--color-error)" />
      <span className={styles.message}>{message}</span>
      {onReview && (
        <button type="button" className={styles.reviewLink} onClick={onReview}>
          {t("calendar.blackout.review", { defaultValue: "Review" })}
          <Icon name="ExternalLink" width={12} height={12} color="currentColor" />
        </button>
      )}
    </div>
  )
}

BookingsActionAlert.propTypes = {
  count: PropTypes.number,
  onReview: PropTypes.func,
  /** Shortens the copy for the narrow month day card. */
  isCompact: PropTypes.bool,
  className: PropTypes.string
}

export default BookingsActionAlert
